import Vue from 'vue'
import VueI18n from 'vue-i18n'
import axios from 'axios'
import store from '@/store'
import config from '@/config/app'
import Translator from '@/components/mixins/Translator'

Vue.use(VueI18n)

const loadedLanguages = [] // our default language that is preloaded

function setI18nLanguage (lang) {
  i18n.locale = lang
  Vue.set(config, 'dateFormats', {...config.dateFormats, ...config.appConfigDateFormats[lang]})
  axios.defaults.headers.common['Accept-Language'] = lang
  document.querySelector('html').setAttribute('lang', lang)
  return lang
}

let cancelToken = null
export function loadLanguageAsync (langFromSwitcher = null) {
  //  Check if there are any previous pending requests
  if (cancelToken !== null) {
    cancelToken.cancel()
    console.log('locale Operation canceled due to new request.')
  }

  let brand = config.BRAND
  let lang = langFromSwitcher || localeProperties.getUserLocale
  store.commit('setSelectedLanguage', lang.toLowerCase())

  if (loadedLanguages.includes(lang)) {
    if (i18n.locale !== lang) setI18nLanguage(lang)
    return Promise.resolve()
  }
  let trnUrl = Translator.methods.trnMakeBrandDictionaryUrl(lang, brand)
  //  Save the cancel token for the current request
  cancelToken = axios.CancelToken.source()

  return axios.get(trnUrl + '?v=' + new Date().getTime(), { cancelToken: cancelToken.token }).then(response => {
    let msgs = response.data
    loadedLanguages.push(lang)
    // console.log('Translator.trnExtractOverrides', Translator.methods.trnExtractOverrides(Translator.methods.translatorBaseDictionaryEn(), msgs, 'all')) // uncomment to extra differences
    let msgs2 = Translator.methods.trnMakeDictionary(lang, msgs)
    i18n.setLocaleMessage(lang, msgs2)
    setI18nLanguage(lang)
    store.commit('setTranslationsLoaded', true)
  }).catch(() => {
    store.commit('setTranslationsLoaded', false)
  }).finally(() => {
    // Set to initial value after every request
    // This is not necessary, if the request is fullfiled there would be nothing to cancel
    // But it won't get into if statement from beginning of the function on every locale change
    cancelToken = null
  })
}

export const localeProperties = {
  get getDefaultLocale () {
    return config.language.toUpperCase() === 'UK' ? 'EN' : config.language
  },
  get getSupportedLocales () {
    return config.autoconf.SUPPORTED_LANGUAGE || [this.getDefaultLocale]
  },
  get getCurrentLocale () {
    return i18n.locale
  },
  get getUserLocale () {
    if (this.isMultiLangEnabled) {
      if (localStorage.userLocale && this.isLocaleSupported(localStorage.userLocale.toUpperCase())) {
        return localStorage.userLocale.toLowerCase()
      }
      return this.getDefaultLocale.toLowerCase()
    }
    return config.language.toLowerCase()
  },
  get getInternalLocale () {
    if (this.isMultiLangEnabled) {
      return this.getUserLocale === 'en' ? 'uk' : this.getUserLocale
    }
    return config.language
  },
  get isMultiLangEnabled () {
    return true
  },
  isLocaleSupported (locale) {
    locale = locale ? locale.toUpperCase() : locale
    return this.getSupportedLocales.includes(locale)
  },
  get routerLang () {
    return this.isMultiLangEnabled ? '/:lang' : ''
  },
  get routerPathLang () {
    return this.isMultiLangEnabled ? '/' + this.getCurrentLocale.toLowerCase() : ''
  }
}

export const i18n = new VueI18n({
  locale: localeProperties.getUserLocale,
  fallbackLocale: localeProperties.getDefaultLocale,
  silentTranslationWarn: true,
  msgs: {}
})



// WEBPACK FOOTER //
// ./src/library/locale/i18n.js